import { AssistantContext } from 'app/domains/assistant';
import { DocumentChatMessageType } from 'shared/domains/apollo/generated/types';
export const getChatTypeByContext = (context) => {
    switch (context) {
        case AssistantContext.Document:
            return DocumentChatMessageType.DocumentAsk;
        case AssistantContext.Selection:
            return DocumentChatMessageType.SelectionAsk;
        default:
            return null;
    }
};
